module.exports = __webpack_public_path__ + "img/Tapeworm.20bc27ec.png";